/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoValidationMessage implements angular.IDirective {
    restrict = "E";
    scope = {
      name: "@",
      contentKey: "@",
      overrideShow: "=",
      hidePostRequiredText: "=?"
    };

    require = "^form";

    link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, formCtrl: any) => {
      let html = "";
      if (formCtrl != null && formCtrl.$name !== "") {

        /* Build path for ngMessages */
        let root = "scope.";
        let prefix = "$parent.";
        let suffix = formCtrl.$name;

        while (eval(root + prefix + suffix) === undefined) {
          prefix = prefix + "$parent.";
        }
        let postRequiredText = " required";
        if (scope.hidePostRequiredText != null && scope.hidePostRequiredText) {
            postRequiredText = "";
        }

        let path = prefix + formCtrl.$name + "." + scope.name;

         let show = path + ".$dirty";
        if (angular.isDefined(scope.overrideShow) || scope.overrideShow) {
            show = "overrideShow";
        }
        html += "<div ng-messages='" + path + ".$error\' ng-show='" + show + "'>";
        html += "<div ng-message='required'><span translate='{{::contentKey}}' />"+postRequiredText+"</div>";
        html += "</div>";
        html += "<div ng-messages='" + path + ".$error\' ng-show='" + path + ".$invalid'>";
        html += "<div ng-message='unique'><span translate='{{::contentKey}}' /></div>";
        html += "<div ng-message='pattern'><span translate='{{::contentKey}}' /><span translate='MESSAGE_INVALID'/></div>";
        html += "<div ng-message='warning'><span translate='{{::contentKey}}' /></div>";
        html += "</div>";

        element.append(html);
        this.$compile(element.contents())(scope);
      }
    }

    
    constructor(private $compile: angular.ICompileService) {

    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($compile) => {
        return new MeevoValidationMessage($compile);
      };

      directive.$inject = ["$compile"];
      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoValidationMessage", MeevoValidationMessage.factory());

}